import { Icon } from '@iconify/react';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import peopleFill from '@iconify/icons-eva/people-fill';
import shoppingBagFill from '@iconify/icons-eva/shopping-bag-fill';
import fileTextFill from '@iconify/icons-eva/file-text-fill';
import lockFill from '@iconify/icons-eva/lock-fill';
import award from '@iconify/icons-eva/award-fill';
import personAddFill from '@iconify/icons-eva/person-add-fill';
import alertTriangleFill from '@iconify/icons-eva/alert-triangle-fill';

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon(pieChart2Fill),
   
  },
  {
    title: 'user',
    path: '/dashboard/user/listing',
    icon: getIcon(peopleFill),
    children:[{
      title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon(pieChart2Fill),
    }]
   },
  {
    title: 'user role',
    path: '/dashboard/userRole',
    icon: getIcon(award),
    children:[{
      title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon(pieChart2Fill),
    }]
  },
  {
    title: 'product category',
    path: '/dashboard/productcategory',
    icon: getIcon(award),
    children:[{
      title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon(pieChart2Fill),
    }]
  },
  {
    title: 'product ',
    path: '/dashboard/product',
    icon: getIcon(award)
  },
  // {
  //   title: 'blog',
  //   path: '/dashboard/blog',
  //   icon: getIcon(fileTextFill)
  // },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: getIcon(lockFill)
  // },
  // {
  //   title: 'register',
  //   path: '/register',
  //   icon: getIcon(personAddFill)
  // },
  {
    title: 'Not found',
    path: '/404',
    icon: getIcon(alertTriangleFill)
  }
];

export default sidebarConfig;
